import React from "react";
import { HiOutlineInformationCircle, HiOutlineTrash } from "react-icons/hi";

/**
 * Body content for the “delete policy category” confirmation modal.
 */
const PolicyCategoryDeleteConfirmContent = ({
  categoryName,
  defaultCategoryName = "Policy Document",
}) => {
  const safeName =
    typeof categoryName === "string" && categoryName.trim().length > 0
      ? categoryName.trim()
      : "this category";

  return (
    <div className='space-y-5'>
      <div className=' rounded-xl border border-blue-100 bg-gradient-to-br from-blue-50/90 to-slate-50/80 px-4 py-3.5 shadow-lg flex gap-4'>
        <div
          className=' flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-red-100 bg-red-50 shadow-lg text-red-600 ring-1 ring-red-100/80'
          aria-hidden
        >
          <HiOutlineTrash className='h-6 w-6' />
        </div>
        <div className='min-w-0 flex-1 pt-0.5'>
          <p className='text-base font-semibold text-gray-900'>
            Delete &ldquo;{safeName}&rdquo;?
          </p>
          <p className='mt-1.5 text-sm leading-relaxed text-gray-600'>
          Every policy currently in &ldquo;{safeName}&rdquo; is reassigned to
              the default category{" "}
              <span className='font-semibold text-slate-800'>
                &ldquo;{defaultCategoryName}&rdquo;
              </span>
          </p>
        </div>
      </div>

      
    </div>
  );
};

export default PolicyCategoryDeleteConfirmContent;
